let isPlaying = false;

export function playBeep(frequency, duration, type = "success", where = '') {
  console.log("playBeep", frequency, duration, type, where);
  if (isPlaying) return; // Evita execução simultânea

  isPlaying = true;

  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
    oscillator.type = "sine";

    gainNode.gain.setValueAtTime(1, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      0.001,
      audioContext.currentTime + duration
    );

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + duration);

    // Quando o som terminar, liberar novamente
    const totalDuration = type === "error" ? (duration * 2) + 0.1 : duration;

    setTimeout(() => {
      isPlaying = false;
    }, totalDuration * 1000);

    // Toca dois beeps no tipo "error"
    if (type === "error") {
      setTimeout(() => {
        const oscillator2 = audioContext.createOscillator();
        const gainNode2 = audioContext.createGain();
        oscillator2.connect(gainNode2);
        gainNode2.connect(audioContext.destination);
        oscillator2.frequency.setValueAtTime(frequency, audioContext.currentTime);
        oscillator2.type = "sine";
        gainNode2.gain.setValueAtTime(1, audioContext.currentTime);
        gainNode2.gain.exponentialRampToValueAtTime(
          0.001,
          audioContext.currentTime + duration
        );
        oscillator2.start(audioContext.currentTime);
        oscillator2.stop(audioContext.currentTime + duration);
      }, duration * 1000 + 100);
    }
  } catch (error) {
    console.warn("Could not play beep sound:", error);
    isPlaying = false;
  }
}
